import { render, staticRenderFns } from "./DashBoardAdminCallcenter.vue?vue&type=template&id=a5b19c76"
import script from "./DashBoardAdminCallcenter.vue?vue&type=script&lang=js"
export * from "./DashBoardAdminCallcenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports